import { render, staticRenderFns } from "./CardAdvanceMedal.vue?vue&type=template&id=13615e80&"
import script from "./CardAdvanceMedal.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports